/* eslint-disable import/no-anonymous-default-export */
import MemberActionTypes from './member.types';
import { docodeHexResponse } from '../../_common/common.utils';
import { arrageMemberTab, updateMemberTab } from './member.utils';

const INITIAL_STATE = {
	// Add Member Response
	addMemberResponse: null,
	addMemberDetailsResponse: [],
	// Add Member Other Details Response
	addMemberOtherDetailsResponse: null,
	// Add Member Business Details Response
	addMemberBusinessDetailsResponse: null,
	// Update Member Details Response
	updateMemberDetailsResponse: null,
	// Get Member List Response
	getMemberListResponse: null,
	getMemberListArr: [],
	// Fetch Member Details Response
	fetchMemberDetailsResponse: null,
	fetchMemberDetailsArr: [],
	// Delete Member Details Response
	deleteMemberDetailsResponse: null,
	// Fetch Co Applicant High Mark Details Response
	fetchCoApplicantHighMarkDetailsResponse: null,
	fetchCoApplicantHighMarkDetailsArr: [],
	// Verify Document Details Response
	verifyDocumentDetailsResponse: null,
	// Check High Mark Details Response
	checkHighMarkDetailsResponse: null,
	checkEquifaxDetailsResponse: null,
	// Check Co Applicant High Mark Details Response
	checkCoApplicantHighmarkDetailsResponse: null,
	checkCoApplicantHighmarkDetailsArr: [],
	// Update No Loan Response
	updateNoLoanResponse: null,
	// Check Top Up Loan Response
	checkTopupLoanResponse: null,
	// Update Reject Response
	updateRejectResponse: null,
	// Update Recheck Response
	updateRecheckResponse: null,
	// Fetch Pay Sprint Log Details Response
	fetchPaySprintLogDetailsResponse: null,
	// Fetch Pay Sprint Log Details Array
	fetchPaySprintLogDetailsArr: [],
	fetchMemberAuditDetailsResponse: null,
	fetchMemberAuditDetailsArr: [],
	// Fetch Member Verify Details Response
	fetchMemberVerifyDetailsResponse: null,
	// Update Member Verify Details Response
	updateMemberVerifyDetailsResponse: null,
	updateMemberKYCDetailsResponse: null,
	// Update Member Transfer Details Response
	updateMemberTransferDetailsResponse: null,
	// Fetch Member Verify Details Array
	fetchMemberVerifyDetailsArr: [],
	// Add Member Details
	addMemberDetails: {
		loanType: 'MFI Loan',
		MemberID: '',
		StageCompleted: 0,
		isPhoneNumberVerified: false,
	},

	addMemberDetailsTab: [
		{
			tab: 'VERIFICATION',
			label: 'Verification',
			icon: 'LocalPolice',
			isShow: true,
			isCompleted: false,
			isDisable: false,
		},
		{
			tab: 'LOAN_TYPE',
			label: 'Loan Type',
			icon: 'LocalPlay',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'CREDIT_CHECK',
			label: 'Credit Check',
			icon: 'CreditScore',
			isShow: false,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'BASIC_DETAILS',
			label: 'Basic Details',
			icon: 'Details',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'PERSONAL_DETAILS',
			label: 'Personal Details',
			icon: 'PeopleAlt',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'FAMILY_DETAILS',
			label: 'Family Details',
			icon: 'PeopleOutline',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'NOMINEE_DETAILS',
			label: 'Nominee Details',
			icon: 'PermCameraMic',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'BANK_DETAILS',
			label: 'Bank Details',
			icon: 'MoneyOff',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'HOUSE_DETAILS',
			label: 'House Details',
			icon: 'House',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'MEMBER_DOCUMENT',
			label: 'Member Documents',
			icon: 'Dock',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'NOMINEE_DOCUMENT',
			label: 'Nominee Documents',
			icon: 'DocumentScanner',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'HOUSE_IMAGE',
			label: 'House Images',
			icon: 'HotelClass',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'EXTRA_INFORMATION',
			label: 'Extra Information',
			icon: 'InfoOutline',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'OFFICIAL_DETAILS',
			label: 'Official Details',
			icon: 'WorkOutline',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'NOC_DETAILS',
			label: 'NOC Document Details',
			icon: 'Subscriptions',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'OTHER_DETAILS',
			label: 'Other Details',
			icon: 'Description',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'BUSINESS_INFORMATION',
			label: 'Business Information',
			icon: 'Business',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
		{
			tab: 'COAPPLICANT',
			label: 'Co Applicant',
			icon: 'PersonAddAlt1',
			isShow: true,
			isCompleted: false,
			isDisable: true,
		},
	],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD MEMBER DETAILS START *********************** */
		case MemberActionTypes.ADD_MEMBER_DETAILS_SUCCESS:
			return {
				...state,
				addMemberResponse: action.payload,
				addMemberDetailsResponse: docodeHexResponse(action.payload, 'AddMemberPhoneNumber'),
			};

		case MemberActionTypes.ADD_MEMBER_DETAILS_FAILURE:
			return { ...state, addMemberResponse: action.payload };

		case MemberActionTypes.ADD_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, addMemberResponse: null };
		/** ***************** ADD MEMBER DETAILS END *********************** */

		/** ***************** ADD MEMBER OTHER DETAILS START *********************** */
		case MemberActionTypes.ADD_MEMBER_OTHER_DETAILS_SUCCESS:
			return {
				...state,
				addMemberOtherDetailsResponse: action.payload,
			};

		case MemberActionTypes.ADD_MEMBER_OTHER_DETAILS_FAILURE:
			return { ...state, addMemberOtherDetailsResponse: action.payload };

		case MemberActionTypes.ADD_MEMBER_OTHER_DETAILS_RESPONSE_CHANGED:
			return { ...state, addMemberOtherDetailsResponse: null };
		/** ***************** ADD MEMBER OTHER DETAILS END *********************** */

		/** ***************** ADD MEMBER BUSINESS DETAILS START *********************** */
		case MemberActionTypes.ADD_MEMBER_BUSINESS_DETAILS_SUCCESS:
			return {
				...state,
				addMemberBusinessDetailsResponse: action.payload,
			};

		case MemberActionTypes.ADD_MEMBER_BUSINESS_DETAILS_FAILURE:
			return { ...state, addMemberBusinessDetailsResponse: action.payload };

		case MemberActionTypes.ADD_MEMBER_BUSINESS_DETAILS_RESPONSE_RESET:
			return { ...state, addMemberBusinessDetailsResponse: null };
		/** ***************** ADD MEMBER BUSINESS DETAILS END *********************** */

		/** ***************** UPDATE MEMBER DETAILS START *********************** */
		case MemberActionTypes.UPDATE_MEMBER_DETAILS_SUCCESS:
			return { ...state, updateMemberDetailsResponse: action.payload };

		case MemberActionTypes.UPDATE_MEMBER_DETAILS_FAILURE:
			return { ...state, updateMemberDetailsResponse: action.payload };

		case MemberActionTypes.UPDATE_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateMemberDetailsResponse: null };
		/** ***************** UPDATE MEMBER DETAILS END *********************** */

		/** ***************** GET MEMBER LIST START *********************** */
		case MemberActionTypes.GET_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getMemberListResponse: action.payload,
				getMemberListArr: docodeHexResponse(action.payload, 'GetMemberListKey'),
			};

		case MemberActionTypes.GET_MEMBER_LIST_FAILURE:
			return { ...state, getMemberListResponse: action.payload };

		case MemberActionTypes.GET_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, getMemberListResponse: null };
		/** ***************** GET MEMBER LIST END *********************** */

		/** ***************** FETCH MEMBER DETAILS START *********************** */
		case MemberActionTypes.FETCH_MEMBER_DETAILS_SUCCESS:
			return {
				...state,
				fetchMemberDetailsResponse: action.payload,
				fetchMemberDetailsArr: docodeHexResponse(action.payload, 'FetchMemberDetailsKey'),
			};

		case MemberActionTypes.FETCH_MEMBER_DETAILS_FAILURE:
			return { ...state, fetchMemberDetailsResponse: action.payload };

		case MemberActionTypes.FETCH_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchMemberDetailsResponse: null, fetchMemberDetailsArr: [] };
		/** ***************** FETCH MEMBER DETAILS END *********************** */

		/** ***************** DELETE MEMBER DETAILS START *********************** */
		case MemberActionTypes.DELETE_MEMBER_DETAILS_SUCCESS:
			return { ...state, deleteMemberDetailsResponse: action.payload };

		case MemberActionTypes.DELETE_MEMBER_DETAILS_FAILURE:
			return { ...state, deleteMemberDetailsResponse: action.payload };

		case MemberActionTypes.DELETE_MEMBER_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteMemberDetailsResponse: null };
		/** ***************** DELETE MEMBER DETAILS END *********************** */
		// CO-APPLICANT DETAILS

		/** ***************** CO-APPLICANT HIGHMARK DETAILS START *********************** */
		case MemberActionTypes.FETCH_COAPPLICANT_HIGHMARK_DETAILS_SUCCESS:
			return {
				...state,
				fetchCoApplicantHighMarkDetailsResponse: action.payload,
				fetchCoApplicantHighMarkDetailsArr: docodeHexResponse(
					action.payload,
					'FetchCoApplicantHighMarkDetailsKey',
				),
			};

		case MemberActionTypes.FETCH_COAPPLICANT_HIGHMARK_DETAILS_FAILURE:
			return { ...state, fetchCoApplicantHighMarkDetailsResponse: action.payload };

		case MemberActionTypes.FETCH_COAPPLICANT_HIGHMARK_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchCoApplicantHighMarkDetailsResponse: null,
				fetchCoApplicantHighMarkDetailsArr: [],
			};
		/** ***************** CO-APPLICANT HIGHMARK DETAILS END *********************** */

		// VERIFY DOCUMENT DETAILS
		/** ***************** VERIFY DOCUMENT DETAILS START *********************** */
		case MemberActionTypes.VERIFY_DOCUMENT_DETAILS_SUCCESS:
			return {
				...state,
				verifyDocumentDetailsResponse: action.payload,
			};

		case MemberActionTypes.VERIFY_DOCUMENT_DETAILS_FAILURE:
			return { ...state, verifyDocumentDetailsResponse: action.payload };

		case MemberActionTypes.VERIFY_DOCUMENT_DETAILS_RESPONSE_RESET:
			return {
				...state,
				verifyDocumentDetailsResponse: null,
			};
		/** ***************** VERIFY DOCUMENT DETAILS END *********************** */

		// CHECK HIGHMARK DETAILS
		/** ***************** CHECK HIGHMARK DETAILS START *********************** */
		case MemberActionTypes.CHECK_HIGHMARK_DETAILS_SUCCESS:
			return {
				...state,
				checkHighMarkDetailsResponse: action.payload,
			};

		case MemberActionTypes.CHECK_HIGHMARK_DETAILS_FAILURE:
			return { ...state, checkHighMarkDetailsResponse: action.payload };

		case MemberActionTypes.CHECK_HIGHMARK_DETAILS_RESPONSE_RESET:
			return {
				...state,
				checkHighMarkDetailsResponse: null,
			};
		/** ***************** CHECK HIGHMARK DETAILS END *********************** */
		// CHECK EQUIFAX DETAILS

		/** ***************** CHECK EQUIFAX DETAILS START *********************** */
		case MemberActionTypes.CHECK_EQUIFAX_DETAILS_SUCCESS:
			return {
				...state,
				checkEquifaxDetailsResponse: action.payload,
			};

		case MemberActionTypes.CHECK_EQUIFAX_DETAILS_FAILURE:
			return { ...state, checkEquifaxDetailsResponse: action.payload };

		case MemberActionTypes.CHECK_EQUIFAX_DETAILS_RESPONSE_RESET:
			return {
				...state,
				checkEquifaxDetailsResponse: null,
			};
		/** ***************** CHECK EQUIFAX DETAILS END *********************** */

		// CHECK CO APPLICANT HIGHMARK DETAILS
		/** ***************** CHECK CO-APPLICANT HIGHMARK DETAILS START *********************** */
		case MemberActionTypes.CHECK_COAPPLICANT_HIGHMARK_DETAILS_SUCCESS:
			return {
				...state,
				checkCoApplicantHighmarkDetailsResponse: action.payload,
				checkCoApplicantHighmarkDetailsArr: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case MemberActionTypes.CHECK_COAPPLICANT_HIGHMARK_DETAILS_FAILURE:
			return { ...state, checkCoApplicantHighmarkDetailsResponse: action.payload };

		case MemberActionTypes.CHECK_COAPPLICANT_HIGHMARK_DETAILS_RESPONSE_RESET:
			return {
				...state,
				checkCoApplicantHighmarkDetailsResponse: null,
				checkCoApplicantHighmarkDetailsArr: [],
			};
		/** ***************** CHECK CO-APPLICANT HIGHMARK DETAILS END *********************** */

		// UPDATE NO LOAN MEMBER RESPONSE
		/** ***************** UPDATE NO LOAN MEMBER START *********************** */
		case MemberActionTypes.UPDATE_NO_LOAN_MEMBER_SUCCESS:
			return { ...state, updateNoLoanResponse: action.payload };

		case MemberActionTypes.UPDATE_NO_LOAN_MEMBER_FAILURE:
			return { ...state, updateNoLoanResponse: action.payload };

		case MemberActionTypes.UPDATE_NO_LOAN_MEMBER_RESPONSE_CHANGED:
			return { ...state, updateNoLoanResponse: null };
		/** ***************** UPDATE NO LOAN MEMBER END *********************** */

		// CHECK TOPUP LOAN MEMBER RESPONSE
		/** ***************** CHECK TOPUP LOAN MEMBER START *********************** */
		case MemberActionTypes.CHECK_TOPUP_LOAN_MEMBER_SUCCESS:
			return { ...state, checkTopupLoanResponse: action.payload };

		case MemberActionTypes.CHECK_TOPUP_LOAN_MEMBER_FAILURE:
			return { ...state, checkTopupLoanResponse: action.payload };

		case MemberActionTypes.CHECK_TOPUP_LOAN_MEMBER_RESPONSE_CHANGED:
			return { ...state, checkTopupLoanResponse: null };
		/** ***************** CHECK TOPUP LOAN MEMBER END *********************** */
		// UPDATE REJECT MEMBER RESPONSE
		/** ***************** REJECT MEMBER START *********************** */
		case MemberActionTypes.REJECT_MEMBER_SUCCESS:
			return { ...state, updateRejectResponse: action.payload };

		case MemberActionTypes.REJECT_MEMBER_FAILURE:
			return { ...state, updateRejectResponse: action.payload };

		case MemberActionTypes.REJECT_MEMBER_RESPONSE_CHANGED:
			return { ...state, updateRejectResponse: null };
		/** ***************** REJECT MEMBER END *********************** */
		// UPDATE RECHECK MEMBER RESPONSE
		/** ***************** RECHECK MEMBER START *********************** */
		case MemberActionTypes.RECHECK_MEMBER_SUCCESS:
			return { ...state, updateRecheckResponse: action.payload };

		case MemberActionTypes.RECHECK_MEMBER_FAILURE:
			return { ...state, updateRecheckResponse: action.payload };

		case MemberActionTypes.RECHECK_MEMBER_RESPONSE_CHANGED:
			return { ...state, updateRecheckResponse: null };
		/** ***************** RECHECK MEMBER END *********************** */
		// UPDATE RECHECK MEMBER RESPONSE
		/** ***************** APPROVE MEMBER START *********************** */
		case MemberActionTypes.APPROVE_MEMBER_SUCCESS:
			return { ...state, updateApproveResponse: action.payload };

		case MemberActionTypes.APPROVE_MEMBER_FAILURE:
			return { ...state, updateApproveResponse: action.payload };

		case MemberActionTypes.APPROVE_MEMBER_RESPONSE_CHANGED:
			return { ...state, updateApproveResponse: null };
		/** ***************** APPROVE MEMBER END *********************** */
		// FETCH PAYSPRINT LOG
		/** ***************** FETCH PAYSPRINT DETAILS START *********************** */
		case MemberActionTypes.FETCH_PAYSPRINT_DETAILS_SUCCESS:
			return {
				...state,
				fetchPaySprintLogDetailsResponse: action.payload,
				fetchPaySprintLogDetailsArr: docodeHexResponse(
					action.payload,
					'FetchPaySprintLogDetailsKey',
				),
			};

		case MemberActionTypes.FETCH_PAYSPRINT_DETAILS_FAILURE:
			return { ...state, fetchPaySprintLogDetailsResponse: action.payload };

		case MemberActionTypes.FETCH_PAYSPRINT_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchPaySprintLogDetailsResponse: null,
			};
		/** ***************** FETCH PAYSPRINT DETAILS END *********************** */

		// FETCH PAYSPRINT LOG
		/** ***************** FETCH MEMBER AUDIT DETAILS START *********************** */
		case MemberActionTypes.FETCH_MEMBER_AUDIT_DETAILS_SUCCESS:
			return {
				...state,
				fetchMemberAuditDetailsResponse: action.payload,
			};

		case MemberActionTypes.FETCH_MEMBER_AUDIT_DETAILS_FAILURE:
			return { ...state, fetchMemberAuditDetailsResponse: action.payload };

		case MemberActionTypes.FETCH_MEMBER_AUDIT_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchMemberAuditDetailsResponse: null,
			};
		/** ***************** FETCH MEMBER AUDIT DETAILS END *********************** */

		/** ***************** FETCH MEMBER VERIFY DETAILS START *********************** */
		case MemberActionTypes.FETCH_MEMBER_VERIFY_DETAILS_SUCCESS:
			return {
				...state,
				fetchMemberVerifyDetailsResponse: action.payload,
				fetchMemberVerifyDetailsArr: docodeHexResponse(
					action.payload,
					'MemberVerifyFetchApproveKey',
				),
			};

		case MemberActionTypes.FETCH_MEMBER_VERIFY_DETAILS_FAILURE:
			return { ...state, fetchMemberVerifyDetailsResponse: action.payload };

		case MemberActionTypes.FETCH_MEMBER_VERIFY_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchMemberVerifyDetailsResponse: null,
			};
		/** ***************** FETCH MEMBER VERIFY DETAILS END *********************** */

		/** ***************** UPDATE MEMBER VERIFY DETAILS START *********************** */
		case MemberActionTypes.UPDATE_MEMBER_VERIFY_DETAILS_SUCCESS:
			return {
				...state,
				updateMemberVerifyDetailsResponse: action.payload,
			};

		case MemberActionTypes.UPDATE_MEMBER_VERIFY_DETAILS_FAILURE:
			return { ...state, updateMemberVerifyDetailsResponse: action.payload };

		case MemberActionTypes.UPDATE_MEMBER_VERIFY_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				updateMemberVerifyDetailsResponse: null,
			};
		/** ***************** UPDATE MEMBER VERIFY DETAILS END *********************** */

		/** ***************** UPDATE MEMBER KYC DETAILS START *********************** */
		case MemberActionTypes.UPDATE_MEMBER_KYC_DETAILS_SUCCESS:
			return {
				...state,
				updateMemberKYCDetailsResponse: action.payload,
			};

		case MemberActionTypes.UPDATE_MEMBER_KYC_DETAILS_FAILURE:
			return { ...state, updateMemberKYCDetailsResponse: action.payload };

		case MemberActionTypes.UPDATE_MEMBER_KYC_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				updateMemberKYCDetailsResponse: null,
			};
		/** ***************** UPDATE MEMBER KYC DETAILS END *********************** */

		/** ***************** UPDATE MEMBER TRANSFER DETAILS START *********************** */
		case MemberActionTypes.UPDATE_MEMBER_TRANSFER_DETAILS_SUCCESS:
			return {
				...state,
				updateMemberTransferDetailsResponse: action.payload,
			};

		case MemberActionTypes.UPDATE_MEMBER_TRANSFER_DETAILS_FAILURE:
			return { ...state, updateMemberTransferDetailsResponse: action.payload };

		case MemberActionTypes.UPDATE_MEMBER_TRANSFER_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				updateMemberTransferDetailsResponse: null,
			};
		/** ***************** UPDATE MEMBER TRANSFER DETAILS END *********************** */

		/** ***************** OTHER MEMBER ACTIONS *********************** */
		case MemberActionTypes.ADD_MEMBER_DETAILS:
			return { ...state, addMemberDetails: action.payload };
		case MemberActionTypes.ADD_MEMBER_TAB:
			return {
				...state,
				addMemberDetailsTab: arrageMemberTab(state.addMemberDetailsTab, action.payload),
			};

		case MemberActionTypes.UPDATE_MEMBER_TAB:
			return {
				...state,
				addMemberDetailsTab: updateMemberTab(state.addMemberDetailsTab, action.payload),
			};
		case MemberActionTypes.RESET_MEMBER_DATA:
			return {
				...state,
				addMemberDetails: {
					loanType: 'MFI Loan',
					MemberID: '',
					StageCompleted: 0,
					isPhoneNumberVerified: false,
				},
				addMemberDetailsTab: updateMemberTab(state.addMemberDetailsTab, 'RESET'),
			};
		default:
			return state;
	}
};
